<template>
<div>
    <Modal v-if="showModal" @close="showModal = false">
    <h3 slot="header"> </h3>
    <div slot="body">
        <div  class="col">
            <h3>
            {{ $t('prefs.title.language') }}
            </h3>
                <RadioGroup
                :div_classes=bootstrap_div_classes
                :items=languages
                :change="notify_parent()"
                :default_val="language"
                v-model=language
                />
        </div>
        <div class="col">
            <h3>
                {{ $t('prefs.title.measurement_system') }}
            </h3> 
            <RadioGroupPills
            :div_classes=bootstrap_div_classes
            :items=measurement_systems
                        :change="notify_parent()"
            :default_val="measurement_system"
            v-model=measurement_system
            />
        </div>
        <div class="col">
            <h3>
            {{ $t('prefs.title.currency') }}
            </h3> 
            <p>
            </p>
                <RadioGroupPills
                :div_classes=bootstrap_div_classes
                :change="notify_parent()"
                :items=currencies
                :default_val="currency"
                v-model=currency
                />
        </div>
                <div class="clear">
</div>
    </div>
    </Modal>
  <div id="prefs_button" @click="showModal = true"  class="item">
    <img
    class="flag"
    
     :src=flag_url />
<strong>
 {{ $t('button.settings') }}
  </strong>
  </div>
</div>
</template>

<script>

import settings from '../settings.js'
import RadioGroup from './RadioGroup.vue'
import RadioGroupPills from './RadioGroupPills.vue'
import Modal from './Modal.vue'

export default {

    name: 'Preferences',
    components: {
        RadioGroup,RadioGroupPills, Modal
    },
    data : function(){
        return {
            language : "",
            measurement_system : "",
            currency : "",
            showModal: false
        }
    },
    created() {
        this.measurement_system = settings.get('measurement_system', 'metric')
        this.language = settings.getI18nLocale()
        this.currency = settings.getCurrency()
    },
    watch : {
        language : function(){
            this.settings('setI18nLocale', this.language.split('-')[0], this.language.split('-')[1])
        },
        currency : function(){
            //console.log('currency='+this.currency)
            settings.set('currency', this.currency)
        },
        measurement_system : function(){
            settings.setMeasurementSystem(this.measurement_system)
        }
    },
    computed : {
          languages : function(){
              return [
                  {
                    label: 'English (US/Canada)',
                    icons: ['icons/flag_us_18.png', 'spacer'],
                    value: 'en-US'
                  },{
                    label: 'English (UK/International)',
                    icons: ['icons/flag_gb_18.png', 'spacer'],
                    value: 'en-GB'
                  },{
                    label: 'Français',
                    icons: ['icons/flag_fr_18.png', 'spacer'],

                    value: 'fr-FR'}
              ]
          },
          flag_url : function(){
              let l = this.language.split('-')[1].toLowerCase()
              
              
              
              return "icons/flag_"+l+"_30.png"
              
          },
          measurement_systems : function(){
              return [
                {label: this.$t('Metric'), value: 'metric'},
                {label: this.$t('US'), value: 'us'},
                {label: this.$t('UK'), value: 'uk'}
              ]
          },
          currencies : function(){
              return [
                {label: "$", value: 'usd'},
                {label: "€", value: 'eur'},
                {label: "￥", value: 'jpy'},
                {label: "£", value: 'gbp'},
                {label: "₿", value: 'btc'}
              ]
          },         
          bootstrap_div_classes : () => {
              return "dbtn-group dbtn-group-toggle capitalize"
          }
    },
    methods : {
        notify_parent : function(){
            this.$emit('input', this.$data)
        },
        settings : function(fn, ...args){
            return settings[fn](...args);
        }
    }
}
</script>

<style scoped>
img.flag {
    padding: 2px 2px 0 8px;
    margin: -5px -3px 0 6px;
    float: left;
    }
</style>
